import React, { useEffect, useRef, useState } from 'react';
// Figma Screen: https://www.figma.com/file/isI24MS5FurNhkXfDybGSc/Fibe---Web-Handover?node-id=12066-204497&t=M9CY9w5lkU54PMjR-0
import InformativeCard from '../components/do-not-cancel-informative-card';
import leftarrow from '../../../assets/repayment/leftarrow.svg';
import topFibo from '../../../assets/nach-cancellation/top-fibo.svg';
import leftHalfCircl from '../../../assets/nach-cancellation/left-half-circle.svg';
import rightHalfCircl from '../../../assets/nach-cancellation/right-half-circle.svg';
import bellIcon from '../../../assets/nach-cancellation/bellIcon.svg';
import EnterPanDrawer from '../components/enter-pan-drawer';
import EnterOtpDrawer from '../components/enter-otp-drawer';
import { useNavigate } from 'react-router-dom';
import { FullScreenBackdropLoader } from '../../../fibe-ui';
import { useNachCancellationStore } from '../../../redux/features/nachCancellationSlice';

const PAN_DRAWER = 'PAN_DRAWER';
const OTP_DRAWER = 'OTP_DRAWER';
const NONE = 'NONE';

const KeepYourSmartRepayInformativeScreen = () => {
  const [openDrawerFlag, setOpenDrawerFlag] = useState(NONE);
  const [isLoading, setIsLoading] = useState(false);
  const autoFoucsDrawer = useRef(null);
  const navigate = useNavigate();
  const { updatePanNumber } = useNachCancellationStore();

  const openPanDrawer = () => {
    //DOCS: clearing redux state on side drawer close
    updatePanNumber('');
    setOpenDrawerFlag(PAN_DRAWER);
    setTimeout(() => focusOnChild(), 500);
  };
  const crossButtonClicked = () => {
    //DOCS: clearing redux state on side drawer close
    updatePanNumber('');
    setOpenDrawerFlag(NONE);
  };

  const handleBackButtonClick = () => {
    navigate('/dashboard');
  };

  const handleDrawerState = (drawerStateString) => {
    setOpenDrawerFlag(drawerStateString);
  };

  const handleLoadingState = (value) => {
    setIsLoading(value);
  };

  const focusOnChild = () => {
    autoFoucsDrawer.current.focus();
  };

  useEffect(() => {
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event) {
      history.pushState(null, document.title, location.href);
    });
  }, []);

  return (
    <>
      <FullScreenBackdropLoader isLoading={isLoading} />
      {/* KeepYourSmartRepayInformativeScreen */}
      <div className="p-0 lg:p-6">
        <div className="flex items-center mb-0 lg:mb-5 p-4 lg:p-0 shadow-md lg:shadow-none">
          <img
            className="inline-block mr-4 w-[11px] hover:cursor-pointer"
            src={leftarrow}
            alt="leftarrow"
            onClick={() => navigate('/dashboard')}
          />
          <span className="text-text-primary text-xl md:text-xl">
            Auto Debit
          </span>
        </div>

        <div className="bg-background-primary rounded-t-none lg:rounded-t-2xl border-transparent lg:border border-stroke relative overflow-hidden h-28 lg:h-52">
          <img
            className="absolute left-0 top-0 hidden lg:block"
            src={leftHalfCircl}
            alt="leftHalfCircl"
          />
          <img
            className="absolute -right-[100px] lg:-right-3 top-0"
            src={rightHalfCircl}
            alt="rightHalfCircl"
          />
          <div className="flex justify-between items-center h-full px-6 lg:px-9 relative z-[2]">
            <h3 className="text-sm lg:text-2xl text-text-primary w-4/5 mr-5">
              We recommend you keep your Auto debit{' '}
              <br className="hidden lg:block" />
              active for <br className="block lg:hidden" /> hassle-free
              repayments!
            </h3>

            <div className="w-44 lg:w-auto">
              <img src={topFibo} alt="leftHalfCircl" />
            </div>
          </div>
        </div>

        <div className="p-4 lg:p-0 mt-6 lg:mt-0">
          <div className="rounded-t-2xl lg:rounded-t-none rounded-b-2xl border border-stroke px-2 py-5 lg:px-8 lg:py-7">
            <InformativeCard />

            <div className="p-4 lg:p-0 mt-6 lg:mt-10">
              <div className="bg-stroke p-4 flex items-center rounded-lg mb-10">
                <img src={bellIcon} alt="bellIcon" />
                <div className="ml-4 text-text-primary text-sm">
                  Delay in payment of EMIs due can lead to additional charges
                  and negative credit score.
                </div>
              </div>

              <div className="pb-10 lg:pb-0">
                <button
                  className="hover:bg-teal-600 ease-out duration-500 transition-all bg-accent text-base text-white font-medium p-3 text-center rounded-md shadow-md w-full lg:w-[170px] mr-0 lg:mr-4 mb-3 lg:mb-0"
                  onClick={handleBackButtonClick}
                >
                  Back
                </button>

                <button
                  onClick={openPanDrawer}
                  className="text-accent text-base font-medium w-full lg:w-auto"
                >
                  Cancel Auto Debit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        <div
          className={`w-full h-auto md:w-96 fixed md:right-0 right-[inherit] bottom-0 md:bottom-[inherit]  top-[inherit] md:top-0 md:h-full bg-white transition-all delay-75 z-[3] md:z-[2] rounded-t-3xl md:rounded-t-none ${
            openDrawerFlag !== NONE
              ? 'md:translate-x-0 translate-x-[inherit] translate-y-0 md:translate-y-[inherit]'
              : 'translate-x-[inherit] md:translate-x-96 translate-y-full md:translate-y-[inherit]'
          }`}
        >
          {openDrawerFlag === PAN_DRAWER ? (
            <EnterPanDrawer
              crossButtonClicked={crossButtonClicked}
              handleDrawerState={handleDrawerState}
              handleLoadingState={handleLoadingState}
              autoFoucsDrawer={autoFoucsDrawer}
            />
          ) : null}
          {openDrawerFlag === OTP_DRAWER ? (
            <EnterOtpDrawer
              crossButtonClicked={crossButtonClicked}
              handleDrawerState={handleDrawerState}
              handleLoadingState={handleLoadingState}
            />
          ) : null}
        </div>
      }
      {/* DOCS: Backdrop for loader opening */}
      {openDrawerFlag !== NONE ? (
        <div className="bg-black opacity-50 fixed w-full h-full left-0 transition-all delay-150 top-0 z-[1]">
          &nbsp;
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default KeepYourSmartRepayInformativeScreen;
